import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import styles from "./styles/switch-voice-button.module.scss";
import React from "react";
import UnfilledButton from "@/components/common/unfilled-button";

const SwitchVoiceButton = ({ switchVoiceModalType }) => {
  const { showModal } = useGlobalModalContext();
  const showModelsModal = () =>
    showModal({
      type: switchVoiceModalType,
    });
  return (
    <div className={styles.wrapper}>
      <UnfilledButton
        text={"Switch Voice"}
        onClick={showModelsModal}
        padding={"10px 20px"}
        borderColor={"#F9A825"}
      />
    </div>
  );
};

export default SwitchVoiceButton;
